import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  Card,
  Typography,
  Avatar,
  Drawer,
  useMediaQuery,
  Tooltip,
  IconButton,
  Chip,
  InputAdornment,
  Dialog,
  FormControlLabel,
  Checkbox,
  TablePagination,
} from "@mui/material";
import {
  useGetAllWorkshopFeedbacksQuery,
  useGetUserQuery,
  useGetTaskQuery,
  useCreateTaskMutation,
  useGetCustomerQuery,
  useGetTeamQuery,
  useDeleteWorkshopRegistrationsMutation,
} from "../../../Api/attoDeskApi";
import {
  IWorkShopFeedBack,
  IUserInfo,
} from "../../../Api/Interface/api.interface";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { styled, useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import { useNotifier } from "../../../Core/Notifier";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TableViewIcon from "@mui/icons-material/TableView";
import * as XLSX from "xlsx";
import {
  DataGrid,
  GridColDef,
  GridPagination,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridToolbar,
} from "@mui/x-data-grid";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopUpCustomer from "../Edit/index";
import NewPopUpCustomerSt from "../Edit/status";
import NewPopUpCustomerRe from "../Edit/reschedule";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import ListAltIcon from "@mui/icons-material/ListAlt";
import MessageIcon from "@mui/icons-material/Message";
import InfoIcon from "@mui/icons-material/Info";
import { FcOk, FcCancel } from "react-icons/fc";
import CancelIcon from "@mui/icons-material/Cancel";

const allColumns = [
  "Submission Date",
  "Name",
  "E-mail",
  "Phone Number",
  "Current Will",
  "Property Finance",
  "Personal Health",
  "Have Trust",
  "Tax Planning",
  "Topics Interested",
  "Other Topic",
  "Biggest Concern",
  "How Did You Hear",
  "Other Heard",
  "Rate Session",
  "Comments",
];

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 100,
  });

  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const { data: userData } = useGetUserQuery();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [selectedMeetingData, setSelectedMeetingData] =
    useState<IWorkShopFeedBack | null>(null);
  const { showErrorMessage, showMessage } = useNotifier();
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | "">("");
  const prevClientIdRef = useRef<string | "">("");

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;

  const [selectedStaffId, setSelectedStaffId] = useState<string | "">("");
  const [selectedClientId, setSelectedClientId] = useState<string | "">("");
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | "">("");

  const [selectedRowIds, setSelectedRowIds] = useState<GridRowSelectionModel>(
    []
  );

  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");

  const [selectedFinalStatuses, setSelectedFinalStatuses] = useState<string[]>(
    []
  );

  const [selectedCoursing, setSelectedCoursing] =
    useState<IWorkShopFeedBack | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCoursingSt, setSelectedCoursingSt] =
    useState<IWorkShopFeedBack | null>(null);
  const [openDialogSt, setOpenDialogSt] = useState(false);
  const [selectedCoursingRe, setSelectedCoursingRe] =
    useState<IWorkShopFeedBack | null>(null);
  const [openDialogRe, setOpenDialogRe] = useState(false);

  const [open, setOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<IWorkShopFeedBack | null>(null);
  const [message, setMessage] = useState("");

  const [newDepartment, { isLoading: meetingSaveIsLoading }] =
    useCreateTaskMutation();

  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const { data, isLoading, isError, refetch } = useGetAllWorkshopFeedbacksQuery(
    {
      searchText: currentSearchQuery,
      staffId: selectedStaffId,
      clientId: selectedClientId,
      id: "",
      fromDate: startDateAsDate as Date,
      toDate: endDateAsDate as Date,
      categoryId: selectedCategoryId,
      multi_final_status_filter: selectedFinalStatuses,
    }
  );

  const {
    data: meetingData,
    isLoading: meetingLoading,
    error: meetingIsError,
  } = useGetTaskQuery(
    {
      searchText: "",
      staffId: userId || "",
      clientId: "",
      id: selectedId || "",
      meeting_Date: "",
    },
    {
      skip: !selectedId,
    }
  );

  const fristIndexMeeting = useMemo(() => {
    if (
      meetingData &&
      Array.isArray(meetingData.data) &&
      meetingData.data.length > 0
    ) {
      return meetingData.data[0] as IWorkShopFeedBack;
    }
    return null;
  }, [meetingData]);

  const finalStatusOptions = [
    { label: "Pending", value: "Pending" },
    { label: "Confirm", value: "Confirm" },
    { label: "Completed", value: "Completed" },
    { label: "Cancel", value: "Cancel" },
  ];

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (fristIndexMeeting) {
      setSelectedMeetingData(fristIndexMeeting);
    }
  }, [fristIndexMeeting, meetingLoading]);

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const coursings: IWorkShopFeedBack[] = Array.isArray(data?.data)
    ? (data?.data as IWorkShopFeedBack[])
    : [];

  const handleAddProductClick = () => {
    navigate(`/workshop/create`);
  };

  const handleEmailHistory = () => {
    navigate(`/workshop/newsletter/e-mail/history`);
  };

  const resetFields = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedStaffId("");
    setSelectedClientId("");
    setSelectedCategoryId("");
    setCurrentSearchQuery("");
    setSearchQuery("");
    setSelectedFinalStatuses([]);
  };

  const handleOpenDialog = (coursing: IWorkShopFeedBack) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDialogSt = (coursing: IWorkShopFeedBack) => {
    setSelectedCoursingSt(coursing);
    setOpenDialogSt(true);
  };

  const handleCloseDialogSt = () => {
    setSelectedCoursingSt(null);
    setOpenDialogSt(false);
  };

  const handleOpenDialogRe = (coursing: IWorkShopFeedBack) => {
    setSelectedCoursingRe(coursing);
    setOpenDialogRe(true);
  };

  const handleCloseDialogRe = () => {
    setSelectedCoursingRe(null);
    setOpenDialogRe(false);
  };

  const handleOpen = () => {
    setSelectedColumns(allColumns);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedColumns(allColumns);
    } else {
      setSelectedColumns([]);
    }
  };

  const handleCheckboxChange = (column: string) => {
    setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const handleRowSelection = (selectionModel: GridRowSelectionModel) => {
    setSelectedRowIds(selectionModel);
  };

  const handleNavigate = () => {
    if (selectedRowIds.length > 0) {
      // Pass as query params
      navigate(`/workshop/newsletter/e-mail?ids=${selectedRowIds.join(",")}`);

      // Or pass as state (cleaner)
      // navigate("/emails", { state: { ids: selectedRowIds } });
    }
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const handleExport = () => {
    handleExportExcel(selectedColumns);
    handleClose();
  };
  const [deleteCategory] = useDeleteWorkshopRegistrationsMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        setMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Client");
    }
  };

  const handleOpenDeletePopup = (coursing: IWorkShopFeedBack) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const handleExportExcel = (selectedCols: string[]) => {
    const coursings: IWorkShopFeedBack[] = Array.isArray(data?.data)
      ? (data?.data as IWorkShopFeedBack[])
      : [];

    const selectedRows = coursings.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    if (selectedRows.length === 0) {
      alert("Please select at least one row to export!");
      return;
    }
    const fullExcelData = selectedRows.map((row) => ({
        "Submission Date": dayjs(row.created_at).format("MMM D, YYYY") || "",
        Name: row.full_name || "",
        "E-mail": (row.email_address || "").toLowerCase() || "",
        "Phone Number": formatPhoneNumberForDisplay(row.phone_number) || "",
        "Current Will": row.current_will || "",
        "Property Finance": row.property_fianance || "",
        "Personal Health": row.personal_health || "",
        "Have Trust": row.have_trust || "",
        "Tax Planning": row.tax_planning || "",
        "Topics Interested": Array.isArray(row.topics_intrested)
          ? row.topics_intrested.join(", ")
          : row.topics_intrested || "",
        "Other Topic": row.other_topic || "",
        "Biggest Concern": row.biggest_concern || "",
        "How Did You Hear": row.how_did_your_hear || "",
        "Other Heard": row.other_heard || "",
        "Rate Session": row.rate_session || "",
        Comments: row.comments || "",
      }));

    const filteredExcelData = fullExcelData.map((row) => {
      const filteredRow: any = {};
      selectedCols.forEach((col) => {
        filteredRow[col] = row[col as keyof typeof row];
      });
      return filteredRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "workshop");
    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `workshop_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const columns: GridColDef[] = [
    {
      field: "createDateOnly",
      headerName: "Submission Date",
      minWidth: 100,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? dayjs(params.value).format("MMM D, YYYY") : "";
      },
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 220,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const customerRefId = params.row.name;
        const customer = params.row;
        const tooltipContent = (
          <ul
            style={{
              margin: 0,
              paddingLeft: "16px",
              fontSize: "13px",
              lineHeight: "1.6",
              listStyleType: "disc",
              textAlign: "left",
            }}
          >
            <li>
              <strong>Name:</strong> {customer.name}
            </li>
            <li>
              <strong>Email:</strong> {customer.email}
            </li>
            <li>
              <strong>Phone:</strong> {customer.phone_number}
            </li>
            <li>
              <strong>Current Will:</strong> {customer.current_will}
            </li>
            <li>
              <strong>Property Finance:</strong> {customer.property_fianance}
            </li>
            <li>
              <strong>Personal Health:</strong> {customer.personal_health}
            </li>
            <li>
              <strong>Have Trust:</strong> {customer.have_trust}
            </li>
            <li>
              <strong>Tax Planning:</strong> {customer.tax_planning}
            </li>
            <li>
              <strong>Topics Interested:</strong> {customer.topics_intrested}
            </li>
            <li>
              <strong>Other Topic:</strong> {customer.other_topic}
            </li>
            <li>
              <strong>Biggest Concern:</strong> {customer.biggest_concern}
            </li>
            <li>
              <strong>How Did You Hear:</strong> {customer.how_did_your_hear}
            </li>
            <li>
              <strong>Other Heard:</strong> {customer.other_heard}
            </li>
            <li>
              <strong>Rate Session:</strong> {customer.rate_session}
            </li>
            <li>
              <strong>Comments:</strong> {customer.note}
            </li>
          </ul>
        );
        return (
          <>
            <span
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              {customerRefId}
            </span>
            <Tooltip
              title={tooltipContent}
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#f9f9f9",
                    color: "#333",
                    p: 1.5,
                    border: "1px solid #ddd",
                    boxShadow: 2,
                    maxWidth: 300,
                  },
                },
              }}
            >
              <IconButton size="small">
                <MessageIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "email",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "phone_number",
      headerName: "Phone Number",
      minWidth: 220,
      flex: 1,
      renderCell: (params: GridRenderCellParams) =>
        formatPhoneNumberForDisplay(params.row.phone_number),
    },
    {
        field: "admin_email_received",
        headerName: "Admin Email",
        flex: 1,
        minWidth: 120,
        renderCell: (params: any) =>
          params.value === 1 ? <FcOk size={30} /> : <CancelIcon sx={{ color: "red", fontSize: 32 }} />,
      },
      {
        field: "participant_email_received",
        headerName: "Participant Email",
        flex: 1,
        minWidth: 150,
        renderCell: (params: any) =>
          params.value === 1 ? <FcOk size={30} /> : <CancelIcon sx={{ color: "red", fontSize: 32 }} />,
      },
  ];

  const formattedRows = coursings.map((row) => ({
    id: row.id,
    name: row.full_name,
    workshopDateOnly: row.created_at,
    createDateOnly: row.created_at,
    finalStatus: row.status,
    email: row.email_address,
    phone_number: row.phone_number,
    status: row.status,
    note: row.comments,
    current_will: row.current_will,
    property_fianance: row.property_fianance,
    personal_health: row.personal_health,
    have_trust: row.have_trust,
    tax_planning: row.tax_planning,
    topics_intrested: Array.isArray(row.topics_intrested)
      ? row.topics_intrested.join(", ")
      : "",
    other_topic: row.other_topic,
    biggest_concern: row.biggest_concern,
    how_did_your_hear: row.how_did_your_hear,
    other_heard: row.other_heard,
    rate_session: row.rate_session,
    admin_email_received: row.admin_email_received,
    participant_email_received: row.participant_email_received,

  }));

  const isAllSelected = selectedColumns.length === allColumns.length;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPaginationModel((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = parseInt(event.target.value, 10);
    setPaginationModel({ page: 0, pageSize: value });
  };

  return (
    <div>
      <Card className={classes.card}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ padding: 2, borderBottom: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleToggle}
                    >
                      {isPaperVisible ? "Close Filter" : "Open Filter"}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      // variant="contained"
                      startIcon={<TableViewIcon />}
                      className={classes.addNewButton}
                      onClick={handleOpen}
                      disabled={selectedRowIds.length === 0}
                    >
                      Export to Excel
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {isPaperVisible && (
              <>
                <Grid container spacing={3} my={5} p={4}>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          From Date
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            onChange={handleStartDateChange}
                            value={startDate}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                                InputProps: {
                                  sx: { fontSize: 14 },
                                },
                                InputLabelProps: {
                                  sx: { fontSize: 14 },
                                },
                              },
                            }}
                            className={classes.searchTextField}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={3} md={6} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          To Date
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            onChange={handleEndDateChange}
                            value={endDate}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                                InputProps: {
                                  sx: { fontSize: 14 },
                                },
                                InputLabelProps: {
                                  sx: { fontSize: 14 },
                                },
                              },
                            }}
                            className={classes.searchTextField}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid item lg={3.6} md={12} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Status
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Autocomplete
                          multiple
                          options={finalStatusOptions}
                          value={finalStatusOptions.filter((option) =>
                            selectedFinalStatuses.includes(option.value)
                          )}
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) => {
                            setSelectedFinalStatuses(
                              newValue.map((item) => item.value)
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              placeholder="Select Status..."
                            />
                          )}
                          sx={{ flexGrow: 1, width: "100%" }}
                          size="small"
                          className={classes.searchTextField}
                        />
                      </Grid>
                    </Grid>
                  </Grid> */}
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Search Name / E-mail / Phone Number
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CiSearch
                                  className={classes.searchWidgetIcon}
                                />
                              </InputAdornment>
                            ),
                            classes: {
                              root: classes.formControlList,
                            },
                          }}
                          fullWidth
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          placeholder="Name, E-mail or Phone Number .."
                          sx={{ width: "100%" }}
                          size="small"
                          className={classes.searchTextField}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box display="flex" justifyContent="flex-end">
                      <Button
                        variant="outlined"
                        startIcon={<RestartAltIcon />}
                        className={classes.addButton}
                        onClick={resetFields}
                      >
                        Reset
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}
            <Grid>
              <Grid
                item
                sx={{ width: "100%", pb: 5, borderTop: 2, pt: 3 }}
                className={classes.titleGrid}
              >
                <div style={{ width: "100%" }}>
                  <TablePagination
                    component="div"
                    count={formattedRows.length}
                    page={paginationModel.page}
                    onPageChange={handleChangePage}
                    rowsPerPage={paginationModel.pageSize}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[
                      5,
                      10,
                      20,
                      50,
                      100,
                      formattedRows.length,
                    ]}
                  />
                  <DataGrid
                    rows={formattedRows.slice(
                      paginationModel.page * paginationModel.pageSize,
                      (paginationModel.page + 1) * paginationModel.pageSize
                    )}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                    rowHeight={60}
                    checkboxSelection
                    disableRowSelectionOnClick
                    className={classes.dataGridTable}
                    onRowSelectionModelChange={handleRowSelection}
                    hideFooter
                  />
                  {/* <DataGrid
                    rows={formattedRows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                    pagination
                    initialState={{
                      pagination: { paginationModel: { pageSize: 100 } },
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    style={{ height: "100%", width: "100%" }}
                    className={classes.dataGridTable}
                    rowHeight={60}
                    checkboxSelection
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={handleRowSelection}
                    getRowClassName={(params) =>
                      params.row.bgColor ? `row-bg-${params.row.id}` : ""
                    }
                  /> */}
                </div>
              </Grid>
            </Grid>
          </Grid>

          {/* {selectedCoursing && (
            <NewPopUpCustomer
              openModel={openDialog}
              handleCloseDialog={handleCloseDialog}
              data={selectedCoursing}
            />
          )}
          {selectedCoursingSt && (
            <NewPopUpCustomerSt
              openModel={openDialogSt}
              handleCloseDialog={handleCloseDialogSt}
              data={selectedCoursingSt}
            />
          )}
          {selectedCoursingRe && (
            <NewPopUpCustomerRe
              openModel={openDialogRe}
              handleCloseDialog={handleCloseDialogRe}
              data={selectedCoursingRe}
            />
          )} */}

          {coursingToDelete && (
            <DeletePopup
              open={openDeleteCategory}
              handleCloseDelete={handleCloseDeletePopup}
              onConfirm={async () => {
                await handleDelete(coursingToDelete.id.toString());
              }}
              title="Delete Participant"
              content={`Are you sure you want to delete "${coursingToDelete.full_name}"?`}
            />
          )}

          <Dialog
            open={open}
            onClose={handleClose}
            aria-describedby="alert-dialog-description"
            classes={{ paper: "inherit" }}
            fullScreen={isMobile}
            fullWidth={isMobile}
            maxWidth="lg"
          >
            <Grid className={classes.Dialog}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Select Columns to Export
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={3} p={"24px"}>
                          <Grid container spacing={3} p={"24px"}>
                            <>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={isAllSelected}
                                      indeterminate={
                                        selectedColumns.length > 0 &&
                                        !isAllSelected
                                      }
                                      onChange={handleSelectAllChange}
                                    />
                                  }
                                  label="Select All"
                                />
                              </Grid>

                              {allColumns.map((column) => (
                                <Grid
                                  item
                                  lg={3}
                                  md={3}
                                  sm={12}
                                  xs={12}
                                  key={column}
                                >
                                  <FormControlLabel
                                    key={column}
                                    control={
                                      <Checkbox
                                        checked={selectedColumns.includes(
                                          column
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(column)
                                        }
                                      />
                                    }
                                    label={column}
                                  />
                                </Grid>
                              ))}
                            </>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid container spacing={3} p={"24px"}>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Button
                              variant="outlined"
                              startIcon={<CloseIcon />}
                              className={classes.addButton}
                              onClick={handleClose}
                            >
                              Cancel
                            </Button>
                            <Box m={0.5}></Box>

                            <Button
                              variant="contained"
                              startIcon={<TableViewIcon />}
                              className={classes.addButton}
                              onClick={handleExport}
                              disabled={
                                selectedColumns.length === 0 ||
                                selectedRowIds.length === 0
                              }
                              // disabled={
                              //   !selectedRowIds || selectedRowIds.length === 0
                              // }
                            >
                              Export
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Dialog>
        </Grid>
      </Card>
    </div>
  );
};

export default Index;
